import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Sidebar from '../layouts/Sidebar';
import Topbar from '../layouts/Topbar';
import ChatWidget from '../features/chat/ChatWidget';
import { AuthenticatedRoutes, PublicRoutes } from './AppRoutes';
import { RealTimeChatProvider } from '../features/chat/context/RealTimeChatContext';
import '../shared/styles/App.css';

function App() {
    const [user, setUser] = React.useState(() => {
        const storedUser = localStorage.getItem('user');
        return storedUser ? JSON.parse(storedUser) : null;
    });

    const [isLoggedIn, setIsLoggedIn] = React.useState(() => {
        return localStorage.getItem('access_token') !== null;
    });

    const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(true);
    const [globalSearch, setGlobalSearch] = React.useState('');

    const handleLogin = (status, userData) => {
        setIsLoggedIn(status);
        if (userData) setUser(userData);
    };

    return (
        <Router>
            <RealTimeChatProvider isLoggedIn={isLoggedIn} user={user}>
                <div className={`App ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>

                    {isLoggedIn ? (
                        <>
                            <Sidebar
                                user={user}
                                isCollapsed={isSidebarCollapsed}
                                setIsCollapsed={setIsSidebarCollapsed}
                            />
                            <main className="main-content">
                                <Topbar
                                    user={user}
                                    globalSearch={globalSearch}
                                    setGlobalSearch={setGlobalSearch}
                                />
                                <AuthenticatedRoutes user={user} globalSearch={globalSearch} />
                            </main>
                            <ChatWidget user={user} />
                        </>
                    ) : (
                        <PublicRoutes onLogin={handleLogin} />
                    )}
                </div>
            </RealTimeChatProvider>
        </Router>
    );
}


export default App;
